import Vue from "vue";
import Router from "vue-router";
import { canShowFeature } from "@/utils/feature-access";
import store from "@/store";
import { user_routes } from "./routes/user";

Vue.use(Router);

const originalPush = Router.prototype.push;

const legacyHappyCoinRouteMap = {
  battle: "happyCoinBattle",
  battleDetail: "happyCoinBattleDetail",
  upgradeList: "happyCoinUpgrade",
  upgradeDetail: "happyCoinUpgradeDetail",
  box: "happyCoinBox",
  boxClassics: "happyCoinBox",
  case: "happyCoinCase",
  multiplePeopleCaseDetail: "happyCoinMultiplePeopleCaseDetail",
};

let createRouter = () => new Router({
  mode: "history",
  routes: [
    {
      path: "/internal-login",
      alias: "/login",
      name: "internalLogin",
      meta: { jurisdiction: 0 },
      component: () => import("@/pages/internalLogin"),
    },
    {
      path: "/",
      meta: { jurisdiction: 0 },
      component: () => import("@/views/home/home.vue"),
      children: [
        /** 首页 */
        {
          path: "/",
          name: "home",
          meta: { jurisdiction: 0, type: "home", keepScroll: true, featureKey: "home" },
          component: () => import("@/pages/home"),
        },
        {
          path: "box",
          name: "box",
          meta: { jurisdiction: 0, type: "home", keepAlive: true },
          component: () => import("@/pages/box/index.vue"),
          redirect: "/box/classics",
          children: [
            {
              path: "classics",
              name: "boxClassics",
              meta: { jurisdiction: 0, type: "home", keepScroll: true, featureKey: "box" },
              component: () => import("@/pages/box/classics"),
            },
            {
              path: "exclusive",
              name: "boxExclusive",
              meta: { jurisdiction: 0, type: "home", featureKey: "box" },
              component: () => import("@/pages/box/exclusive"),
            },
            {
              path: "exclusivedetail/:id",
              name: "exclusiveDetail",
              meta: { jurisdiction: 0, type: "home", featureKey: "box" },
              component: () => import("@/pages/box/exclusive/detail/index.vue"),
            },
            // 自建盒子
            {
              path: "diy",
              name: "boxDiy",
              meta: { jurisdiction: 0, type: "home", featureKey: "box_diy" },
              component: () => import("@/pages/box/diy/index.vue"),
            },
            // 创建箱子
            {
              path: "create",
              name: "boxCreate",
              meta: { jurisdiction: 0, type: "home", featureKey: "box_diy" },
              component: () => import("@/pages/box/create/index.vue"),
            },
            // 我创建的箱子（支持 /box/mine?id=4 传入箱子 id）
            {
              path: "mine",
              name: "boxMine",
              meta: { jurisdiction: 0, type: "home", featureKey: "box_diy" },
              component: () => import("@/pages/box/mine/index.vue"),
            },
            {
              path: "share",
              name: "boxShare",
              meta: { jurisdiction: 0, type: "home", featureKey: "box_diy" },
              component: () => import("@/pages/box/share/index.vue"),
            },
          ],
        },
        {
          path: "happyCoinBox",
          meta: {
            jurisdiction: 0,
            type: "home",
            featureKey: "happy_coin_box",
            currencyMode: "happyCoin",
          },
          component: () => import("@/pages/box/index.vue"),
          children: [
            {
              path: "",
              name: "happyCoinBox",
              meta: {
                jurisdiction: 0,
                type: "home",
                keepScroll: true,
                featureKey: "happy_coin_box",
                currencyMode: "happyCoin",
                aclPath: "/box/classics",
                navRouteName: "boxClassics",
              },
              component: () => import("@/pages/box/classics"),
            },
            {
              path: "case/:id",
              name: "happyCoinCase",
              meta: {
                jurisdiction: 0,
                type: "home",
                featureKey: "happy_coin_box",
                currencyMode: "happyCoin",
                aclPath: "/box/classics",
                navRouteName: "boxClassics",
              },
              component: () => import("@/pages/case"),
            },
            {
              path: "multiple/:id",
              name: "happyCoinMultiplePeopleCaseDetail",
              meta: {
                jurisdiction: 0,
                type: "home",
                requiresAuth: true,
                featureKey: "happy_coin_box",
                currencyMode: "happyCoin",
                aclPath: "/box/classics",
                navRouteName: "boxClassics",
              },
              component: () => import("@/pages/multiplePeopleCase"),
            },
          ],
        },
        {
          path: "/crash",
          meta: { jurisdiction: 0, type: "home", keepScroll: true, featureKey: "crash" },
          component: () => import("@/pages/crash/entertainment"),
          children: [
            {
              path: "/",
              name: "crash",
              meta: { jurisdiction: 0, type: "home", featureKey: "crash" },
              component: () => import("@/pages/crash/index.vue"),
            },
            {
              path: "history",
              name: "crashHistory",
              meta: { jurisdiction: 0, type: "home", featureKey: "crash" },
              component: () => import("@/pages/crash/history/index.vue"),
            },
            {
              path: "history/:id",
              name: "crashHistoryDetail",
              meta: { jurisdiction: 0, type: "home", featureKey: "crash" },
              component: () => import("@/pages/crash/historyDetail/index.vue"),
            }
          ]
        },
        {
          path: "/happyCoinCrash",
          meta: { jurisdiction: 0, type: "home", keepScroll: true, featureKey: "happy_coin_crash", currencyType: 1, currencyMode: "happyCoin" },
          component: () => import("@/pages/crash/entertainment"),
          children: [
            { path: "/", name: "happyCoinCrash", meta: { jurisdiction: 0, type: "home", featureKey: "happy_coin_crash", currencyType: 1, currencyMode: "happyCoin" }, component: () => import("@/pages/crash/index.vue") },
            { path: "history", name: "happyCoinCrashHistory", meta: { jurisdiction: 0, type: "home", featureKey: "happy_coin_crash", currencyType: 1, currencyMode: "happyCoin" }, component: () => import("@/pages/crash/history/index.vue") },
            { path: "history/:id", name: "happyCoinCrashHistoryDetail", meta: { jurisdiction: 0, type: "home", featureKey: "happy_coin_crash", currencyType: 1, currencyMode: "happyCoin" }, component: () => import("@/pages/crash/historyDetail/index.vue") }
          ]
        },
        {
          path: "/coin1Crash",
          meta: { jurisdiction: 0, type: "home", keepScroll: true, featureKey: "coin1_coin_crash", currencyType: 2, currencyMode: "coin1" },
          component: () => import("@/pages/crash/entertainment"),
          children: [
            { path: "/", name: "coin1Crash", meta: { jurisdiction: 0, type: "home", featureKey: "coin1_coin_crash", currencyType: 2, currencyMode: "coin1" }, component: () => import("@/pages/crash/index.vue") },
            { path: "history", name: "coin1CrashHistory", meta: { jurisdiction: 0, type: "home", featureKey: "coin1_coin_crash", currencyType: 2, currencyMode: "coin1" }, component: () => import("@/pages/crash/history/index.vue") },
            { path: "history/:id", name: "coin1CrashHistoryDetail", meta: { jurisdiction: 0, type: "home", featureKey: "coin1_coin_crash", currencyType: 2, currencyMode: "coin1" }, component: () => import("@/pages/crash/historyDetail/index.vue") }
          ]
        },
        {
          path: "/chicken-road",
          meta: { jurisdiction: 0, type: "home", keepScroll: true, featureKey: "chicken_road" },
          component: () => import("@/pages/chicken-road/index.vue"),
          children: [
            {
              path: "/",
              name: "chicken-road",
              meta: { jurisdiction: 0, type: "home" },
              component: () => import("@/pages/chicken-road/home.vue"),
            },
            {
              path: "history",
              name: "chickenRoadHistory",
              meta: { jurisdiction: 0, type: "home" },
              component: () => import("@/pages/chicken-road/history.vue"),
            }
          ]
        },
        {
          path: "/happyCoinChickenRoad",
          meta: { jurisdiction: 0, type: "home", keepScroll: true, featureKey: "happy_coin_chicken", currencyType: 1, currencyMode: "happyCoin" },
          component: () => import("@/pages/chicken-road/index.vue"),
          children: [
            { path: "/", name: "happyCoinChickenRoad", meta: { jurisdiction: 0, type: "home", featureKey: "happy_coin_chicken", currencyType: 1, currencyMode: "happyCoin" }, component: () => import("@/pages/chicken-road/home.vue") },
            { path: "history", name: "happyCoinChickenRoadHistory", meta: { jurisdiction: 0, type: "home", featureKey: "happy_coin_chicken", currencyType: 1, currencyMode: "happyCoin" }, component: () => import("@/pages/chicken-road/history.vue") }
          ]
        },
        {
          path: "/coin1ChickenRoad",
          meta: { jurisdiction: 0, type: "home", keepScroll: true, featureKey: "coin1_coin_chicken", currencyType: 2, currencyMode: "coin1" },
          component: () => import("@/pages/chicken-road/index.vue"),
          children: [
            { path: "/", name: "coin1ChickenRoad", meta: { jurisdiction: 0, type: "home", featureKey: "coin1_coin_chicken", currencyType: 2, currencyMode: "coin1" }, component: () => import("@/pages/chicken-road/home.vue") },
            { path: "history", name: "coin1ChickenRoadHistory", meta: { jurisdiction: 0, type: "home", featureKey: "coin1_coin_chicken", currencyType: 2, currencyMode: "coin1" }, component: () => import("@/pages/chicken-road/history.vue") }
          ]
        },
        {
          path: "/happyCoinWheel",
          meta: { jurisdiction: 0, type: "home", keepScroll: true, featureKey: "happy_coin_wheel", currencyType: 1, currencyMode: "happyCoin" },
          component: () => import("@/pages/wheel/index.vue"),
          children: [
            { path: "/", name: "happyCoinWheel", meta: { jurisdiction: 0, type: "home", featureKey: "happy_coin_wheel", currencyType: 1, currencyMode: "happyCoin" }, component: () => import("@/pages/wheel/Home.vue") },
            { path: "history", name: "happyCoinWheelHistory", meta: { jurisdiction: 0, type: "home", featureKey: "happy_coin_wheel", currencyType: 1, currencyMode: "happyCoin" }, component: () => import("@/pages/wheel/History.vue") },
            { path: "history/:id", name: "happyCoinCrashHistoryDetail", meta: { jurisdiction: 0, type: "home", featureKey: "happy_coin_wheel", currencyType: 1, currencyMode: "happyCoin" }, component: () => import("@/pages/wheel/Round.vue") }

          ]
        },
        {
          path: "/coin1Wheel",
          meta: { jurisdiction: 0, type: "home", keepScroll: true, featureKey: "coin1_coin_wheel", currencyType: 2, currencyMode: "coin1" },
          component: () => import("@/pages/wheel/index.vue"),
          children: [
            { path: "/", name: "coin1Wheel", meta: { jurisdiction: 0, type: "home", featureKey: "coin1_coin_wheel", currencyType: 2, currencyMode: "coin1" }, component: () => import("@/pages/wheel/Home.vue") },
            { path: "history", name: "coin1WheelHistory", meta: { jurisdiction: 0, type: "home", featureKey: "coin1_coin_wheel", currencyType: 2, currencyMode: "coin1" }, component: () => import("@/pages/wheel/History.vue") },
            { path: "history/:id", name: "coin1WheelHistoryDetail", meta: { jurisdiction: 0, type: "home", featureKey: "coin1_coin_wheel", currencyType: 2, currencyMode: "coin1" }, component: () => import("@/pages/wheel/Round.vue") }

          ]
        },
        {
          path: "/wheel",
          meta: { jurisdiction: 0, type: "home", keepScroll: true, featureKey: "wheel" },
          component: () => import("@/pages/wheel/index.vue"),
          children: [
            { path: "/", name: "wheel", meta: { jurisdiction: 0, type: "home", featureKey: "wheel" }, component: () => import("@/pages/wheel/Home.vue") },
            { path: "history", name: "wheelHistory", meta: { jurisdiction: 0, type: "home", featureKey: "wheel" }, component: () => import("@/pages/wheel/History.vue") },
            { path: "history/:id", name: "happyCoinWheelHistoryDetail", meta: { jurisdiction: 0, type: "home"}, component: () => import("@/pages/wheel/Round.vue") }
          ]
        },
        {
          path: "/battle-royale",
          name: "battleRoyale",
          meta: { jurisdiction: 0, type: "home", requiresAuth: true, featureKey: "battle_royale" },
          component: () => import("@/pages/battleRoyale/index.vue"),
        },
        {
          path: "/battle-royale/room/:roomId",
          name: "battleRoyaleRoom",
          meta: { jurisdiction: 0, type: "home", requiresAuth: true, featureKey: "battle_royale" },
          component: () => import("@/pages/battleRoyale/room.vue"),
        },
        /** 拉货对战 */
        {
          path: "battle",
          name: "battle",
          meta: { jurisdiction: 0, type: "home", requiresAuth: true, featureKey: "battle" },
          component: () => import("@/pages/battle"),
        },
        {
          path: "happyCoinBattle",
          name: "happyCoinBattle",
          meta: {
            jurisdiction: 0,
            type: "home",
            requiresAuth: true,
            featureKey: "happy_coin_battle",
            currencyMode: "happyCoin",
            aclPath: "/battle",
            navRouteName: "battle",
          },
          component: () => import("@/pages/battle"),
        },
        /** poggi */
        {
          path: "poggi",
          name: "poggi",
          meta: { jurisdiction: 0, type: "home", requiresAuth: true, featureKey: "poggi" },
          component: () => import("@/pages/poggi"),
        },
        {
          path: "/happyCoinPoggi",
          name: "happyCoinPoggi",
          meta: { jurisdiction: 0, type: "home", requiresAuth: true, featureKey: "happy_coin_poggi", currencyType: 1, currencyMode: "happyCoin" },
          component: () => import("@/pages/poggi"),
        },
        {
          path: "/coin1Poggi",
          name: "coin1Poggi",
          meta: { jurisdiction: 0, type: "home", requiresAuth: true, featureKey: "coin1_coin_poggi", currencyType: 2, currencyMode: "coin1" },
          component: () => import("@/pages/poggi"),
        },
        {
          path: "battleDetail/:id",
          name: "battleDetail",
          meta: { jurisdiction: 0, type: "home", requiresAuth: true, featureKey: "battle" },
          component: () => import("@/pages/battle/battle_detail"),
        },
        {
          path: "happyCoinBattle/detail/:id",
          name: "happyCoinBattleDetail",
          meta: {
            jurisdiction: 0,
            type: "home",
            requiresAuth: true,
            featureKey: "happy_coin_battle",
            currencyMode: "happyCoin",
            aclPath: "/battle",
            navRouteName: "battle",
          },
          component: () => import("@/pages/battle/battle_detail"),
        },

        {
          path: "battleHistory",
          name: "battleHistory",
          meta: { jurisdiction: 0, type: "home", requiresAuth: true, featureKey: "battle" },
          component: () => import("@/pages/battle/battleHistory"),
        },
        {
          path: "gameInstanceBox/:sort",
          name: "gameInstanceBox",
          meta: { jurisdiction: 0, type: "home" },
          component: () => import("@/pages/gameInstanceBox"),
        },
        /** 开箱详情 */
        {
          path: "case/:id",
          name: "case",
          meta: { jurisdiction: 0, type: "home" },
          component: () => import("@/pages/case"),
        },
        /** 多人开箱列表 */
        {
          path: "multiplePeopleCaseList/:tabType",
          name: "multiplePeopleCaseList",
          meta: { jurisdiction: 0, type: "home", requiresAuth: true, featureKey: "multiple_people_case" },
          component: () =>
            import("@/pages/multiplePeopleCase/multiplePeopleCase_list"),
        },
        /** 多人开箱详情 */
        {
          path: "multiplePeopleCaseDetail/:id",
          name: "multiplePeopleCaseDetail",
          meta: { jurisdiction: 0, type: "home", requiresAuth: true },
          component: () => import("@/pages/multiplePeopleCase"),
        },
        /** 汰换合同 */
        {
          path: "upgrade",
          name: "upgrade",
          meta: { jurisdiction: 0, type: "home" },
          component: () => import("@/pages/upgrade/index.vue"),
          redirect: "/upgrade/list",
          children: [
            /** 升级列表 */
            {
              path: "list",
              name: "upgradeList",
              meta: { jurisdiction: 0, type: "home", keepAlive: true, featureKey: "upgrade" },
              component: () => import("@/pages/upgrade/list/index.vue"),
            },
            /** 升级详情 */
            {
              path: "detail",
              name: "upgradeDetail",
              meta: { jurisdiction: 0, type: "home", featureKey: "upgrade" },
              component: () => import("@/pages/upgrade/detail/index.vue"),
            },
            {
              path: "upgrade2",
              name: "upgrade2Detail",
              meta: { jurisdiction: 0, type: "home", featureKey: "upgrade_euro" },
              component: () => import("@/pages/upgrade2/detail/index.vue"),
            },
          ],
        },
        {
          path: "happyCoinUpgrade",
          meta: {
            jurisdiction: 0,
            type: "home",
            featureKey: "happy_coin_upgrade",
            currencyMode: "happyCoin",
          },
          component: () => import("@/pages/upgrade/index.vue"),
          children: [
            {
              path: "",
              name: "happyCoinUpgrade",
              meta: {
                jurisdiction: 0,
                type: "home",
                keepAlive: true,
                featureKey: "happy_coin_upgrade",
                currencyMode: "happyCoin",
                aclPath: "/upgrade/list",
                navRouteName: "upgradeList",
              },
              component: () => import("@/pages/upgrade/list/index.vue"),
            },
            {
              path: "detail",
              name: "happyCoinUpgradeDetail",
              meta: {
                jurisdiction: 0,
                type: "home",
                featureKey: "happy_coin_upgrade",
                currencyMode: "happyCoin",
                aclPath: "/upgrade/list",
                navRouteName: "upgradeList",
              },
              component: () => import("@/pages/upgrade/detail/index.vue"),
            },
          ],
        },

        /** Roll福利 */
        {
          path: "rolls",
          name: "rolls",
          meta: { jurisdiction: 0, type: "home", requiresAuth: true, featureKey: "rolls" },
          component: () => import("@/pages/rolls"),
        },

        {
          path: "rollDetail/:id",
          name: "rollDetail",
          meta: { jurisdiction: 0, type: "home", requiresAuth: true, featureKey: "rolls" },
          component: () => import("@/pages/rollDetail/rollDetail.vue"),
        },
        {
          path: "rollCreate",
          name: "rollCreate",
          meta: { jurisdiction: 0, type: "home", requiresAuth: true, featureKey: "rolls" },
          component: () => import("@/pages/rollCreate/index.vue"),
        },
        {
          path: "rollCreateItems",
          name: "rollCreateItems",
          meta: { jurisdiction: 0, type: "home", requiresAuth: true, featureKey: "rolls" },
          component: () => import("@/pages/rollCreateItems/index.vue"),
        },
        {
          path: "worldcup",
          name: "worldcup",
          meta: { jurisdiction: 0, type: "home", featureKey: "jollybeans" },
          component: () => import("@/pages/worldcup/index.vue"),
        },
        {
          path: "worldcupDetail/:id",
          name: "worldcupDetail",
          meta: { jurisdiction: 0, type: "home", featureKey: "jollybeans" },
          component: () => import("@/pages/worldcup/detail.vue"),
        },
        {
          path: "shop",
          name: "shop",
          meta: { jurisdiction: 0, type: "home", featureKey: "shop" },
          component: () => import("@/pages/shop"),
          redirect: "/shop/vip",
          children: [
            {
              path: "gold",
              name: "shopGold",
              meta: { jurisdiction: 0, type: "home", featureKey: "shop_gold" },
              component: () => import("@/pages/shop/mall"),
            },
            {
              path: "vip",
              name: "shopVip",
              meta: { jurisdiction: 0, type: "home", requiresAuth: true, featureKey: "shop_vip" },
              component: () => import("@/pages/shop/mall"),
            },
            {
              path: "uu",
              name: "shopUu",
              meta: { jurisdiction: 0, type: "home", requiresAuth: true, featureKey: "shop_uu" },
              component: () => import("@/pages/shop/mall"),
            },
            {
              path: "happycoin",
              name: "shopHappyCoin",
              meta: { jurisdiction: 0, type: "home", requiresAuth: true, featureKey: "shop_happycoin" },
              component: () => import("@/pages/shop/mall"),
            },
            {
              path: "coin1",
              name: "shopCoin1",
              meta: { jurisdiction: 0, type: "home", requiresAuth: true, featureKey: "shop_coin1" },
              component: () => import("@/pages/shop/mall"),
            },
          ],
        },
        /** 免费盲盒 */
        {
          path: "freebox",
          name: "freebox",
          meta: { jurisdiction: 0, type: "home", featureKey: "freebox" },
          component: () => import("@/pages/freebox"),
        },
        /** 个人中心 */
        ...user_routes,

        /** 帮助中心 */
        {
          path: "faq",
          name: "faq",
          meta: { jurisdiction: 0, type: "home" },
          component: () => import("@/pages/help/help.vue"),
        },
        /** 关于我们 */
        {
          path: "aboutUs",
          name: "aboutUs",
          meta: { jurisdiction: 0, type: "home" },
          component: () => import("@/pages/help/aboutUs.vue"),
        },
        /** 用户协议 */
        {
          path: "agreement",
          name: "agreement",
          meta: { jurisdiction: 0, type: "home" },
          component: () => import("@/pages/help/agreement.vue"),
        },
        /** 用户协议 */
        {
          path: "privacy",
          name: "privacy",
          meta: { jurisdiction: 0, type: "home" },
          component: () => import("@/pages/help/privacy.vue"),
        },
        /** 协议与条款 */
        {
          path: "clause",
          name: "clause",
          meta: { jurisdiction: 0, type: "home" },
          component: () => import("@/pages/help/clause.vue"),
        },
        /** 活动中心 */
        {
          path: "event",
          name: "event",
          meta: { jurisdiction: 0, type: "home", featureKey: "event" },
          component: () => import("@/pages/event/index/index.vue"),
          children: [
            {
              path: "eventIndex",
              name: "eventIndex",
              meta: { jurisdiction: 0, type: "home", featureKey: "event" },
              component: () => import("@/pages/event/index/index.vue"),
            },
            {
              path: "activity",
              name: "activity",
              meta: { jurisdiction: 0, type: "home", featureKey: "activity" },
              component: () => import("@/pages/event/components/activity.vue"),
            },
            {
              path: "rebate",
              name: "rebate",
              meta: { jurisdiction: 0, type: "home", featureKey: "rebate" },
              component: () => import("@/pages/event/components/rebate.vue"),
            },
            {
              path: "redEnvelope",
              name: "redEnvelope",
              meta: { jurisdiction: 0, type: "home", featureKey: "red_envelope" },
              component: () =>
                import("@/pages/event/components/redEnvelope.vue"),
            },
            {
              path: "vipLevel",
              name: "vipLevel",
              meta: { jurisdiction: 0, type: "home", featureKey: "vip_level" },
              component: () => import("@/pages/event/components/vip.vue"),
            },
            {
              path: "subsidy",
              name: "subsidy",
              meta: { jurisdiction: 0, type: "home", featureKey: "event" },
              component: () => import("@/pages/event/components/subsidy.vue"),
            },
          ],
        },
        /** 欢乐豆 */
        {
          path: "jollybeans",
          name: "jollybeans",
          meta: { jurisdiction: 1, type: "user", featureKey: "jollybeans" },
          component: () => import("@/pages/user/jollybeans"),
        },
        /** 金豆 */
        {
          path: "goldbeans",
          name: "goldbeans",
          meta: { jurisdiction: 1, type: "user", featureKey: "coin1" },
          component: () => import("@/pages/user/goldbeans"),
        },
      ],
    },

    /*官网模式路由*/
    {
      path: "/official",
      name: "vessel",
      meta: { jurisdiction: 0 },
      component: () => import("@/views/official/vessel/index.vue"),
      redirect: "/official/home",
      children: [
        //首页
        {
          path: "/official/home",
          name: "officialHome",
          component: () => import("@/views/official/home/index.vue"),
          meta: {
            name: "仿官网首页",
            type: "official",
          },
        },
        //开箱
        {
          path: "/official/case",
          name: "officialCase",
          component: () => import("@/views/official/case/index.vue"),
          meta: {
            name: "仿官网箱子列表",
            type: "official",
          },
        },
        //开箱
        {
          path: "/official/open",
          name: "officialOpen",
          component: () => import("@/views/official/open/index.vue"),
          meta: {
            name: "仿官网开箱",
            type: "official",
          },
        },
        {
          path: "/official/warehouse",
          name: "officialWarehouse",
          component: () => import("@/views/official/warehouse/index.vue"),
          meta: {
            jurisdiction: 1,
            name: "仿官网背包",
            type: "official",
          },
        },
      ],
    },

    {
      path: "/localtion",
      meta: { jurisdiction: 0 },
      component: () => import("@/views/localtion/localtion.vue"),
    },

    {
      path: "*",
      redirect: { name: "home" },
    },

    {
      path: "/luckyfairness",
      meta: { jurisdiction: 0, type: "home" },
      component: () => import("@/pages/luckyFairness/index.vue"),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      // 标记滚动需要延迟
      if (savedPosition && to.meta.keepScroll) {
        to.meta.pendingScroll = savedPosition
        resolve({ x: 0, y: 0 }) // 先返回顶部
      } else {
        resolve({ x: 0, y: 0 })
      }
    })
  },
});
const router = createRouter();
export function resetRouter() { //清空路由的方法
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}
// 登录拦截
router.beforeEach(async (to, from, next) => {
  const legacyHappyCoinRouteName =
    String(to.query.uhc) === "1" && legacyHappyCoinRouteMap[to.name];
  if (legacyHappyCoinRouteName) {
    const query = { ...to.query };
    delete query.uhc;
    return next({
      name: legacyHappyCoinRouteName,
      params: to.params,
      query,
      replace: true,
    });
  }

  if (
    to.fullPath === from.fullPath &&
    !(to.name === "home" && from.name === null && from.path === "/")
  )
    return next(false);
  const featureRoute = [...to.matched]
    .reverse()
    .find(
      (record) =>
        record.meta.featureKey
        && !canShowFeature(
          router.app.$store.state.featureAccess,
          record.meta.featureKey
        )
    );
  if (
    featureRoute
    && to.name !== "home"
  ) {
    return next({ name: "home" });
  }
  //校验登录
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    var user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) {
      router.app.$store.commit("setloginModal", true);
      return next({ name: "home" });
    }
  }
  // 權限控制
  const aclList = router.app.$store.state.acl;
  console.log('router===aclList==', aclList)
  const aclRoute = [...to.matched]
    .reverse()
    .find((record) => record.meta.aclPath);
  const aclPath = aclRoute ? aclRoute.meta.aclPath : to.path;
  if (aclList.indexOf(aclPath) > -1) {
    return next({ name: "home" });
  }

  // 判断域名是否为IP地址
  const is_ip_address =
    window.location.hostname.search(/\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/) !==
    -1;
  // 获取子域名
  const domain_code = window.location.hostname.split(".").reverse()[2];

  // 设置二级域名邀请码(主播专属域名)
  if (
    !is_ip_address &&
    typeof domain_code !== "undefined" &&
    ["www"].indexOf(domain_code) === -1 &&
    ["kjcs2"].indexOf(domain_code) === -1 &&
    ["dev-web"].indexOf(domain_code) === -1
  ) {
    // 设置主播邀请码
    sessionStorage.setItem("author_code", domain_code);
    sessionStorage.setItem("code", domain_code);
  }

  // 存储第三方 Code
  if (to.query.code) {
    sessionStorage.setItem("code", to.query.code);
  }

  if (to.query.channel) {
    sessionStorage.setItem("channel", to.query.channel);
  }

  if (to.path.indexOf("/official") > -1) {
    var user = JSON.parse(sessionStorage.getItem("user"));
    if (!user || user.userType != 1) {
      return next({ name: "home" });
    }
  }

  if (sessionStorage.getItem("user")) {
    store.commit("setloginModal", false);

    return next();
  }

  if (
    to.matched.every((item) => {
      return item.meta.jurisdiction === 0;
    })
  ) {
    store.commit("setloginModal", false);

    return next();
  }

  store.commit("setloginModal", true);

  return next();
});

export default router;
